import { MoreAboutMeState } from './State'

import { SET_RESPONSE, SET_RESPONSES, MoreAboutMeAction } from './Actions'

function moreAboutMeReducer(state: MoreAboutMeState, action: MoreAboutMeAction): MoreAboutMeState {
  switch (action.type) {
    case SET_RESPONSE:
      return Object.assign({}, state, { [action.payload.questionKey]: action.payload.response })
    case SET_RESPONSES:
      return Object.assign({}, state, action.payload)
    default:
      return state
  }
}

export default moreAboutMeReducer
